export default {
    index: {
        content: "「心光」是使用者的 AI 生活夥伴，就像是生活版的 Notion。你可以用它 All-in-one 記錄生活：文字、語音、照片影片、靈感想法、情緒發洩、音樂播客、健身運動…… 同時，由你親自設定的 AI 朋友會主動回應你的心情，與你產生共鳴，或展開深入的對話。",
        contentTips: "——日積月累，你將擁有一本屬於自己的「人生之書」，和世界上最懂你的 AI 朋友。",
        iosDownload: "iOS 下載"
    },
    // 菜单
    header: {
        home: '首頁',
        about: '關於我們'
    },
    //关于页面
    aboutUs: {
        content: "「心光」的使命：為用戶構建有陪伴、有回應、有梳理的個人小世界，讓想法和情緒被妥善照料。結合強大的 AI 能力，心光的 AI 朋友既是你生活的傾聽者，也是得力助手，陪伴你的人生，伴隨你成為更棒的自己。",
        //联系我们
        contact: "聯絡我們",
        //注销账号
        contactTips1: "如需註銷帳號，請發送電子郵件至：moodlightnlp2025@gmail.com，郵件中請提供您的手機號碼或郵箱信息，我們將第一時間為您處理！",
        contactTips2: "註銷帳號屬於危險操作，請確認是否要註銷帳號。請注意如您完成註銷帳號操作後，您的帳號會進入3天的帳號刪除冷靜期，在冷靜期中您再次登入此帳號，將視為您取消帳號註銷，刪除冷靜期結束後，我們會刪除您的帳號資訊且無法找回，由於您的應用程式資料儲存在您的應用程式內，如您需要刪除應用程式資料且無法找回，由於您的應用程式資料儲存在您的應用程式內，如您需要刪除應用程式資料也可直接刪除應用程式資料。",
    },
    //隐私政策
    privacy_policy: {
        title: "隱私政策",
        company: "營運公司：深圳市心裡有光科技有限公司",
        published_on: "本隱私政策於2024年12月20日發布。",
        updated_on: "本隱私政策於2025年04月07日更新。",
        description: "心光是由深圳市心裡有光科技有限公司（以下簡稱「心裡有光科技有限公司」或「我們」）為您提供是你的AI生活記錄伴侶。心裡有光科技有限公司十分重視您的個人信息和數據，並會盡全力保護您的個人信息和數據的安全可靠。本心光應用（下文簡稱「本應用」或「心光」）非常重視用戶隱私政策並嚴格遵守相關的法律規定。請您仔細閱讀《隱私政策》後再繼續使用。如果您繼續使用我們心裡有光科技有限公司的服務，表示您已經充分閱讀和理解我們協議的全部內容。",
        helpYouKnow: "本政策將幫助您了解以下內容：",
        sections: [
            "一、我們如何收集您的個人信息",
            "二、我們如何存儲您的個人信息",
            "三、我們如何保障您的個人信息安全",
            "四、Cookie和同類技術的使用",
            "五、我們如何使用您的個人信息",
            "六、您如何管理您的信息",
            "七、信息披露",
            "八、我們如何處理兒童的個人信息",
            "九、本隱私政策的更改",
            "十、如何聯繫我們"
        ],
        disclaimer: "本應用尊重並保護所有使用服務用戶的個人隱私權。為了給您提供更準確、更優質的服務，本應用會按照本隱私權政策的規定使用和披露您的個人信息。除本隱私權政策另有規定外，在未徵得您事先許可的情況下，本應用不會將這些信息對外披露或向第三方提供。本應用會不時更新本隱私權政策。您在同意本應用服務使用協議之時，即視為您已經同意本隱私權政策全部內容。",

        //第一节
        section1: {
            declare: "在您使用心光服務的過程中，心光會按照如下方式收集您在使用服務時主動提供或因為使用服務而產生的信息，用以向您提供服務、優化我們的服務以及保障您的帳號安全：",
            declares: [
                "1、當您註冊心光服務時，我們會收集您的暱稱、頭像、手機號碼，收集這些信息是為了幫助您完成心光註冊，保護您心光帳號的安全。手機號碼屬於敏感信息，收集此類信息是為了滿足相關法律法規的網絡實名制要求。若您不提供這類信息，您可能無法正常使用我們的服務。您還可以根據自身需求選擇填寫性別、描述等信息。",
                "2、當您使用心光服務時，為保障您正常使用我們的服務，維護我們服務的正常運行，改進及優化我們的服務體驗以及保障您的帳號安全，我們會收集您的設備型號、操作系統、唯一設備識別碼（指由設備製造商編入到設備中的一串字符，可用於以獨有方式標識相應設備）、登錄IP地址、心光軟件版本號、接入網絡的方式、類型和狀態、網絡質量數據、設備加速器（如重力感應設備）、操作日誌、服務日誌信息（如您在心光進行搜索、查看操作的記錄、服務故障信息、推薦網址等信息）等日誌信息，這類信息是為提供服務必須收集的基礎信息。",
                "3、當您使用心光進行日常記錄時，我們會獲取您包括但不限於記錄文本、照片、影片等您上傳到心光的記錄信息，您的這些信息將存儲在應用內，您可以選擇是否存儲到心光的伺服器，因為存儲是實現這一功能所必需的。我們會以加密的方式存儲，您也可以隨時刪除這些信息。除非經您自主選擇或遵從相關法律法規要求，我們不會對外提供上述信息，或者將其用於該功能以外的其他用途。",
                "4、當您通過訂購會員等產品時產生的記錄，包括訂購記錄、消費記錄，這些信息會存儲於我們的伺服器中。以上信息為軟件功能必須的信息。如您使用訂購與支付功能，第三方提供支付服務的公司將直接收集與支付相關的信息。",
                "5、當您使用AI相關功能時，我們認為您允許心光將您在心光上產生的如記錄信息等用戶信息提供給第三方提供AI服務的公司，以獲得AI的相關服務。",
                "6、當您使用本軟件時，為提供給您服務之目的，心光可能獲取您終端設備的如下權限，當然您可以拒絕開啟以下權限，或在手機的設置中關閉本軟件的以下權限，關閉以下權限不會影響您對本軟件其他功能的使用：",
            ],
            sixth: [
                "（1）訪問相機：您可以使用攝像頭直接拍攝並上傳圖片；",
                "（2）獲取電話和接受短信：通過開啟電話權限，實現手機號接收驗證碼短信註冊登錄；",
                "（3）訪問本地存儲：通過開啟本地存儲權限，實現應用的更新和本地照片與視頻上傳；",
                "（4）訪問照片：您可以直接選擇手機內的照片或圖片進行上傳；",
                "（5）開啟無線數據：您可以通过连接无线网络或开启蜂窝网络来实现本软件需要的联网功能；",
                "另外，根據相關法律法規及國家標準，以下情形中，我們可能會收集、使用您的相關個人信息無需徵求您的授權同意：",
            ],
            sixthPoint: [
                "a) 與個人信息控制者履行法律法規規定的義務相關的；",
                "b) 與國家安全、國防安全直接相關的；",
                "c) 與公共安全、公共衛生、重大公共利益直接相關的；",
                "d) 與刑事偵查、起訴、審判和判決執行等直接相關的；",
                "e) 出於維護個人信息主體或其他個人的生命、財產等重大合法權益但又很難得到本人授權同意的；",
                "f) 所涉及的个人信息是个人信息主体自行向社会公众公开的；",
                "g) 根据个人信息主体要求签订和履行合同所必需的；",
                "h) 从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；",
                "i) 维护所提供产品或服务的安全稳定运行所必需的，如发现、处置产品或服务的故障；",
                "j) 个人信息控制者为新闻单位，且其开展合法的新闻报道所必需的；",
                "k) 个人信息控制者为学术研究机构，出于公共利益开展统计或学术研究所必要，且其对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的。",
            ],
            understand: "請您理解，我們向您提供的功能和服務是不斷更新和發展的，如果某一功能或服務未在前述說明中且收集了您的信息，我們會通過頁面提示、交互流程、網站公告等方式另行向您說明信息收集的內容、範圍和目的，以徵得您的同意。",
            notice: "請您注意，目前心光不會主動從心光外的第三方獲取您的個人信息。如未來為業務發展需要從第三方間接獲取您個人信息，我們會在獲取前向您明示您個人信息的來源、類型及使用範圍。此外，我們也將嚴格遵守相關法律法規的規定，並要求第三方保障其提供的信息的合法性。",
        },

        //第二节
        section2: {
            titles: [
                "1、資訊存儲的地點",
                "2、資訊存儲的期限",
                "3、帳號資訊的生成和註銷"
            ],
            firstPoint: "目前您的大部分數據存儲於您的應用內，其它諸如帳號信息等存儲在心光伺服器的信息，我們會按照法律法規規定，將境內收集的用戶個人信息存儲於中國境內。如果您的個人信息存儲地點從中國境內轉移到境外的，我們將嚴格依照法律的規定執行。",
            secondPoint: {
                content: "一般而言，我們僅在為實現目的所必需的時間內保留您的個人信息，例如",
                points: [
                    "手機號碼：若您需要使用心光服務，我們需要一直保存您的手機號碼，以保證您正常使用心光的相關服務，當您註銷心光帳戶後，我們將刪除相應的信息；",
                    "用戶信息：若您使用心光服務，我們需要一直保存您的暱稱、性別、描述等信息，以保證您正常使用該服務，當您註銷心光帳戶後，我們將刪除相應的信息；"
                ]
            },
            thirdPoint: [
                "當您通過應用內手機號時，我們將根據您的手機號生成您在應用內的帳號。",
                "當您需要註銷帳號時，請通過[設置]-[帳號與安全]-[註銷帳號]來進行帳號的註銷，當您註銷帳號後，我們將刪除所有關於您的帳號信息和用戶信息，並無法找回，請在註銷前確定導出您所需要的用戶信息。"
            ]
        },

        //第三节
        section3: {
            content: [
                "我們努力為用戶的信息安全提供保障，以防止信息的丟失、不當使用、未經授權訪問或披露。",
                "我們將在合理的安全水平內使用各種安全保護措施以保障信息的安全。例如，我們會使用加密技術（例如，SSL）、匿名化處理等手段來保護您的個人信息。",
                "我們通過不斷提升的技術手段加強安裝在您設備端的軟件的安全能力，以防止您的個人信息洩露。例如，我們為了安全傳輸會在您設備本地完成部分信息加密的工作；為了預防病毒、木馬程序或其他惡意程序、網站，我們可能會了解您設備安裝的應用信息、正在運行的進程信息或設備內存中寄存的數據；為了預防詐騙、盜號、仿冒他人等不法行為和進行安全檢查可能會分析利用唯一設備標識符、登錄IP地址、操作日誌、地理位置信息等數據，以便於採取安全措施或進行安全提醒等。",
                "我們建立專門的管理制度、流程和組織以保障信息的安全。例如，我們嚴格限制訪問信息的人員範圍，要求他們遵守保密義務，並進行審計。",
                "若發生個人信息洩露等安全事件，我們會啟動應急預案，阻止安全事件擴大，並以推送通知、公告等形式告知您。",
                "我們會盡力保護您的個人信息。我們也請您理解，任何安全措施都無法做到無懈可擊。"
            ]
        },
        //第四节
        section4: {
            content: [
                "在您未拒絕接受cookies的情況下，本應用會在您的計算機上設定或取用cookies ，以便您能登錄或使用依賴於cookies的本應用平台服務或功能。本應用使用cookies可為您提供更加周到的服務，包括推廣服務。",
                "通過本應用所設cookies所取得的有關信息，將適用本政策。"
            ]
        },
        //第五节
        section5: {
            content: [
                "我們可能將通過某些功能所收集的信息用於我們的其他服務。例如，我們可能會將您在使用我們某一功能或服務時所收集的信息進行處理，並在分析後提供相關統計服務，包括但不限於數據分類展示、對您閱讀過的內容進行信息安全提示、基於特徵標籤進行間接人群畫像並提供更精準的服務和內容、保護用戶權益或心光生態系統的安全等。",
                "為了確保服務的安全性，幫助我們更好地了解應用程式的運行情況，我們可能會記錄相關信息，例如您使用應用程式的頻率、崩潰數據、整體使用情況、性能數據以及應用程式的來源。我們不會將存儲在分析工具中的信息與您在應用程式中提供的任何個人身份信息相結合。",
                "如果我們對您的個人信息的使用超出了最初收集時聲明的目的，或與之無直接或合理關聯的範圍，我們將在使用前再次告知您並取得您的明確同意。"
            ]
        },
        //第六节
        section6: {
            title: [
                "1、信息管理",
                "2、帳號註銷"
            ],
            content1: [
                "我們非常重視您對個人信息的關注，並盡全力保護您對於自己個人信息訪問、更正及刪除的權利，以使您擁有充分的能力保障您的隱私和安全。",
                "當您發現我們處理關於您的信息有錯誤時，您有權要求我們做出更正或補充。我們在提供服務的過程中，可能需要您開通一些設備權限，例如相冊、相機、麥克風、手機通訊錄等訪問權限。您可以在設備的【設置】功能中隨時選擇關閉部分或者全部權限，從而拒絕本應用收集您的個人信息。在不同的設備中，權限顯示方式及關閉方式可能有所不同，具體參考設備及系統開發方說明或指引。"
            ],
            content2: [
                "您可以自行點擊「洞見—>設置—>帳號與安全—>註銷帳號」提示您通過手機號聯繫並驗證真實身份。",
                "點擊「確認註銷」，經驗證身份信息無誤並且註銷帳號意圖不變，我們會將您的帳號進入刪除冷靜期，在刪除冷靜期過程中您將無法使用您的帳號，但您可以要求我們恢復您的帳號信息，待刪除冷靜期過後您的帳號將被完全刪除，如果您希望立即刪除您的帳號信息，您可以通過郵箱與我們聯繫，我們將立即為您處理帳號註銷，此外由於您的其它數據存儲在您的應用中，您可自行刪除心光應用，您的數據也會被同步刪除。",
                "您知悉並同意，帳號註銷的行為是不可逆的。在您主動註銷帳號之後，本應用將停止為您提供產品或服務，會儘快刪除您的個人信息或做匿名化處理，但法律法規另有規定的除外。"
            ]
        },
        //第七节
        section7: {
            notice: "在如下情况下，本應用將依據您的個人意願或法律的規定全部或部分的披露您的個人信息：",
            notices: [
                "(a) 未經您事先同意，我們不會向第三方披露；",
                "(b) 為提供您所要求的產品和服務，而必須和第三方分享您的個人信息；",
                "(c) 根據法律的有關規定，或者行政或司法機構的要求，向第三方或者行政、司法機構披露；",
                "(d) 如您出現違反中國有關法律、法規或者本應用服務協議或相關規則的情況，需要向第三方披露；",
                "(e) 如您是合格的知識產權投訴人並已提起投訴，應被投訴人要求，向被投訴人披露，以便雙方處理可能的權利糾紛；"
            ],
            title: [
                "1、共享",
                "2、轉讓",
                "3、公開披露",
                "4、委託處理",
                "5、關於和第三方合作商的信息披露"
            ],
            content1: [
                {
                    title: "（1）其他用戶查詢",
                    content: "本應用中其他用戶可以通過搜索查詢到您再本應用中的用戶主頁或已發布的物品，方便用戶之間的交換。"
                },
                {
                    title: "（2）投訴處理",
                    content: "當您投訴他人或被他人投訴時，為了保護您及他人的合法權益，維護本應用內綠色交換環境，我們可能會將您的姓名及有效證件號碼、聯繫方式、投訴相關內容提供給有關部門，以便及時解決投訴糾紛，但法律法規明確禁止提供的除外。"
                }
            ],
            content2: {
                notice: "我們不會將您的個人信息轉讓給任何公司、組織和個人，但以下情況除外：",
                notices: [
                    "（1）事先獲得您的明確同意；",
                    "（2）根據法律法規或強制性的行政或司法要求；",
                    "（3）在涉及資產轉讓、收購、兼併、重組或破產清算時，如涉及到個人信息轉讓，我們會向您告知有關情況，並要求新的持有您個人信息的公司、組織繼續受本政策的約束。如變更個人信息的處理目的、處理方式時，我們將要求該公司、組織重新取得您的明確同意。"
                ]
            },
            content3: {
                notice: "原則上我們不會將您的信息進行公開披露，如確需公開披露時，我們會向您告知公開披露的目的、披露信息的類型及可能涉及的敏感信息，並徵得您的明確同意。"
            },
            content4: {
                notice: "為了提升信息處理效率，降低信息處理成本，或提高信息處理準確性，我們可能會委託有能力的我們的關聯公司或其他專業機構代表我們來處理信息。我們會通過書面協議、現場審計等方式要求受託公司遵守嚴格的保密義務及採取有效的保密措施，禁止其將這些信息用於未經您授權的用途。在委託關係解除時，受託公司不再保存個人信息。我們承諾對此負責。"
            },
            content5: {
                services: [
                    {
                        title: "1）支付服務提供商之一：由深圳市騰訊計算機系統有限公司為您提供服務，我們將會採集常用設備信息（如IMEI/IMSI、SIM卡序列號/MAC地址、android_id）以及網絡信息與軟件安裝列表，用戶為您提供支付服務，詳細內容請訪問",
                        policyName: "《微信隱私政策》",
                        sdkTips: "以下是支付服務提供商所需要使用到的相關SDK：",
                        link: "https://weixin.qq.com/cgi-bin/readtemplate?lang=zh_CN&t=weixin_agreement&s=privacy",
                        tips: "微信 SDK：用於使用微信支付、微信分享和微信登錄功能"
                    },
                    {
                        title: "2）支付服務提供商之二：由支付寶（中國）網絡技術有限公司為您提供服務，我們將會採集IMEI、IMSI、MAC 地址、設備序列號、硬件序列號、SIM卡序列號、ICCID、AndroidID、OAID、SSID、BSSID；系統設置、系統屬性、設備型號、設備品牌、操作系統；IP 地址、網絡類型、運營商信息、Wi-Fi 狀態、Wi-Fi 參數、Wi-Fi列表；軟件安裝列表，用於為您提供支付服務，詳細內容請訪問",
                        policyName: "《支付寶隱私權政策》",
                        sdkTips: "以下是信用服務供應商所需要使用到的相關SDK：",
                        link: "https://opendocs.alipay.com/common/02kiq3",
                        tips: "支付寶支付 SDK：用於使用支付寶支付"
                    },
                    {
                        title: "3）異常上報服務提供商：由騰訊科技（北京）有限公司為您提供服務，我們將會採集常用設備信息（如IMEI/IMSI、SIM卡序列號/MAC地址、android_id）以及網絡信息，將用戶在使用過中出現的異常上報給我們，來進一步提升用戶體驗，詳細內容請訪問",
                        policyName: "《Bugly Crash SDK隱私保護聲明》",
                        sdkTips: "以下是異常上報服務提供商所需要使用到的相關SDK：",
                        link: "https://privacy.qq.com/document/preview/fc748b3d96224fdb825ea79e132c1a56",
                        tips: "騰訊 Bugly SDK：用於統計應用內出現崩潰的問題。"
                    },
                    {
                        title: "4）分享服務提供商之一：由行吟信息科技（上海）有限公司️為您提供服務，我們將會採集常用設備信息（操作系統、系統版本、設備型號）以及網絡信息，用於為您提供小紅書分享服務，詳情內容請訪問",
                        policyName: "《小紅書Open SDK個人信息處理說明》",
                        sdkTips: "以下是分享服務提供商所需要使用到的相關SDK：",
                        link: "https://agree.xiaohongshu.com/h5/terms/ZXXY20230525001/-1",
                        tips: "- 小紅書分享SDK：用於完成跳轉到小紅書進行分享"
                    },
                    {
                        title: "5）語音識別服務提供商：由阿里雲計算有限公司為您提供服務，使用過程中不會收集您的設備信息，為您提供語音識別服務，詳細內容請訪問",
                        policyName: "《智能語音交互產品隱私政策》",
                        sdkTips: "以下是語音識別服務提供商所需要使用到的相關SDK：",
                        link: "https://terms.alicdn.com/legal-agreement/terms/b_platform_service_agreement/20240325163900980/20240325163900980.html?spm=a2c4g.11186623.0.0.62e34f4dX2l2z4",
                        tips: "- 智能語音交互移動端SDK：用於進行智能語音交互"
                    }, {
                        "title": "6）號碼認證服務提供商：由阿里雲計算有限公司為您提供服務，我們將會採集網路類型、設備資訊（含IP位址、設備製造商、設備型號、手機作業系統、SIM卡資訊SIM State），用於為您提供手機號一鍵登入服務，詳情內容請訪問",
                        "policyName": "《號碼認證服務隱私權政策》",
                        "sdkTips": "以下是號碼認證服務提供商所需要使用到的相關SDK：",
                        "link": "https://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud202112211045_86198.html?spm=a2c4g.11186623.0.0.7e503079Pt4iQ9",
                        "tips": "- 號碼認證服務SDK：用於實現手機號一鍵登入"
                    }
                ],
                notice: "此外，當軟件在後台運行時部分第三方SDK收集個人信息情況的告知：",
                noticeTips: "（1）騰訊Bugly SDK在後台運行時會讀取SD卡存儲相關內容，其需要讀取應用的相關信息，將產生的崩潰情況和具體崩潰產生的位置上報到服務器"
            }
        },
        //第八节
        section8: {
            content: [
                "我們非常重視兒童個人信息的保護，我們的產品、網站和服務主要面向成人。如果沒有父母或監護人的同意，兒童不應創建自己的用戶帳戶。儘管當地法律和習俗對兒童的定義不同，但我們將未滿 14 周歲的任何人均視為兒童。",
                "對於經父母或監護人同意而收集的兒童用戶信息，我們只會在受到法律允許、父母或監護人明確同意或者為保護兒童所必要的情況下儲存、使用或公開披露此信息，否則我們會設法盡快刪除相關數據。",
                "鑒於現有技術和業務模式的限制，我們很難主動識別兒童的個人信息，如果您發現我們在不知情的情況下或在未事先獲得可證實的監護人同意的情況下收集了兒童的個人信息，您可以及時與我們聯繫，我們將在發現後設法及時刪除；如果我們自己發現前述情形，我們也會及時刪除，法律要求保留的除外。"
            ]
        },
        //第九节
        section9: {
            content: [
                "(a) 如果決定更改隱私政策，我們會在本政策中、本公司網站中以及本應用的系統訊息中進行通知，以便您了解我們如何收集、使用您的個人信息，哪些人可以訪問這些信息，以及在什麼情況下我們會透露這些信息。",
                "(b) 本公司保留隨時修改本政策的權利，因此請經常查看。如對本政策作出重大更改，本公司會以系統訊息和短信的形式告知。",
                "(c) 請您妥善保護自己的個人信息，僅在必要的情形下向他人提供。如您發現自己的個人信息洩密，尤其是本應用用戶名及密碼發生洩露，請您立即聯絡本應用客服，以便本應用採取相應措施。",
                "感謝您花時間了解我們的隱私政策！我們將盡全力保護您的個人信息和合法權益，再次感謝您的信任！"
            ]
        },
        section10: {
            noticePre: "我們設立了個人信息保護專職部門，將按照本政策保護您的個人信息。如您有關於網絡信息安全的投訴和舉報，或您對本政策、心光的隱私措施、您的信息的相關事宜有任何問題、意見或建議，請與心光的個人信息保護工作人員聯繫，可發送郵件至",
            noticeSub: "一般情況下，我們將在收到您的問題、意見或建議，並驗證您的用戶身份後的十五天內予以回復。"
        }
    },
    //用户须知
    agreement: {
        mainTitle: "用戶協議",
        company: "運營公司：深圳市心裡有光科技有限公司",
        published_on: "本隱私政策發布於：2024年12月20日",
        updated_on: "本隱私政策更新於：2025年1月1日",
        title: [
            "1. 您的權利",
            "2. 服務條款的接受與修改",
            "3. 會員服務購買聲明",
            "4. 會員的購買",
            "5.會員的有效期以及退訂",
            "6.協議的有效期和終止",
            "7.違約責任",
            "8.爭議解決和法律適用"
        ],
        section1: {
            notice: "我們非常重視您的隱私與個人信息安全，您的信任對我們至關重要。根據中國的法律法規，我們為您提供以下權利，確保您的個人信息安全、可控：",
            title: [
                "（一）訪問您的個人信息",
                "（二）修改您的個人信息",
                "（三）刪除您的個人信息",
                "（四）改變您授權的範圍",
                "（五）註銷賬戶",
                "（六）響應您的上述請求",
            ],
            firstNotice: "您有權訪問您的個人信息，法律法規規定的例外情況除外，可以通過以下方式進行訪問：",
            firstTips: "訪問暱稱、性別、描述等基本信息：",
            firstTipsSteps: [
                "進入後，點擊“陪伴”",
                "點擊最上方的AI朋友區域",
                "進行個人信息信息查詢",
            ],
            secondNotice: "當您發現您的個人信息有錯誤時，您可直接通過“(一)訪問您的個人信息”的路徑對您的個人信息直接進行修改。",
            thirdNotice: "在以下情形中，您可以向我們提出刪除個人信息的請求：",
            thirdTips: [
                "如果我們在處理您的個人信息時違反法律法規；",
                "如果我們收集或使用您的個人信息時未徵得您的同意；",
                "如果我們處理您的個人信息時違反了與您的約定；",
                "如果您不再使用我們的產品或服務或您註銷了帳號；",
                "如果我們不再為您提供產品或服務。",
            ],
            thirdEnd: [
                "若我們決定響應您的刪除請求，我們還將同時通知從我們獲得您的個人信息的實體，要求其及時刪除，除非法律法規另有規定，或這些實體獲得您的獨立授權。",
                "刪除方式：當您從我們的服務中刪除信息後，我們可能不會立即從系統中刪除相應的信息，我們會設立一段刪除冷靜期，在這段時間內您還可以要求我們為您恢復您的個人信息，待刪除冷靜期過後，您的數據將會被徹底刪除。",
            ],
            fourthNotice: "每個業務功能需要一些基本的個人信息才能得以完成。對於額外收集的個人信息的收集和使用，您可以隨時給予或收回您的授權同意。 當您收回同意後，我們將不再處理相應的個人信息。",
            fifthNotice: "您隨時可註銷此前提註冊的賬戶，您可以通過以下方式自行操作：",
            fifthNoticeSteps: [
                "進入後，點擊“洞見”",
                "點擊“設置”",
                "點擊“賬號與安全”",
                "點擊“註銷賬號”",
            ],
            fifthTips: "在註銷賬戶之後，我們將停止為您提供產品或服務，並依據您的要求，刪除您的個人信息，法律法規另有規定的除外。",
            fifthOtherWise: "在以下情形中，按照法律法規要求，我們將無法響應您的請求：",
            fifthOtherSteps: [
                "與國家安全、國防安全直接相關的；",
                "與公共安全、公共衛生、重大公共利益直接相關的；",
                "與犯罪偵查、起訴、審判和判決執行等直接相關的；",
                "有充分證據表明您存在主觀惡意或濫用權利的；",
                "響應您的請求將導致您或其他個人、組織的合法權益受到嚴重損害的；",
                "涉及商業秘密的。",
            ],
            sixthNotice: [
                "為保障安全，您可能需要提供書面請求，或以其他方式證明您的身份。我們可能會先要求您驗證自己的身份，然後再處理您的請求。 我們將在驗證您身份後的三十天內作出答覆。如您不滿意，還可以依法向政府或者行業主管部門投訴。",
                "對於您合理的請求，我們原則上不收取費用，但對多次重複、超出合理限度的請求，我們將視情收取一定成本費用。對於那些無端重複、需要過多技術手段（例如，需要開發新系統或從根本上改變現行慣例）、給他人合法權益帶來風險或者非常不切實際（例如，涉及備份磁帶上存放的信息）的請求，我們可能會予以拒絕。",
                "在以下情形中，我們將無法響應您的請求：",
            ],
            sixthSteps: [
                "與個人信息控制者履行法律法規規定的義務相關的；",
                "與國家安全、國防安全直接相關的；",
                "與公共安全、公共衛生、重大公共利益直接相關的；",
                "與刑事偵查、起訴、審判和執行判決等直接相關的；",
                "個人信息控制者有充分證據表明個人信息主體存在主觀惡意或濫用權利的；",
                "出於維護個人信息主體或其他個人的生命、財產等重大合法權益但又很難得到本人同意的；",
                "響應個人信息主體的請求將導致個人信息主體或其他個人、組織的合法權益受到嚴重損害的；",
                "涉及商業秘密的。",
            ]
        },
        //第二节
        section2: {
            notice: [
                "本協議是深圳市心裡有光科技有限公司旗下App心光用戶（以下簡稱「用戶」）與深圳市心裡有光科技有限公司關於用戶權利所訂立的協議，本協議描述深圳市心裡有光科技有限公司與用戶之間關於本服務的使用以及相關方面的權利義務，用戶選擇使用本服務的行為將視為同意本協議各項條款的約束。",
                "本協議如需修改，會將修改部分或新規定通過網站公告發布，會員應及時關注並遵守，所有規定為協議不可分割的組成部分，與本協議正文具有同等效力。若有關規定與本協議不一致，以生效日期在後的規定為準。"
            ]
        },
        //第三节
        section3: {
            notice: [
                "本服務是在用戶期望開通會員以享受AI相關服務的前提下推出的，明確會員與非會員的權利範圍，避免因不明確會員範圍而造成損失而推出的服务。",
                "來電、AI聊天和每週來信等服務，此會員服務範圍並不局限於以上部分，在未來的開發中，心光將推出更多會員服務來滿足會員用戶不同的需求。",
                "如在扣費過程中出現差錯，用戶應積極配合深圳市心裡有光科技有限公司查明原因，各自承擔己方過錯所造成的損失；若因雙方各自存在不均等過錯造成的損失，由雙方按照各自造成損失的程度承擔相應的責任。",
                "除心光應用內的會員購買方式，任何在心光之外付款或者以惡意破解等非法手段獲取到心光會員服務的行為，均不屬於本協議約定的會員服務。由此產生的一切法律後果由行為人負責，深圳市心裡有光科技有限公司有權依法追究行為人的法律責任。"
            ]
        },
        //第四节
        section4: {
            notice: [
                "深圳市心裡有光科技有限公司在心光應用內，向用戶提供了微信、支付寶等支付渠道，便於用戶在選擇不同會員時長時選擇不同的支付方式進行支付來獲取心光會員，享受心光會員服務。",
                "如遇支付成功，但會員時長未增加或會員權利未生效，請及時聯繫深圳市心裡有光科技有限公司，深圳市心裡有光科技有限公司將及時為您處理您的會員生效問題。"
            ]
        },
        //第五节
        section5: {
            notice: "除非深圳市心裡有光科技有限公司另行規定或出現無法繼續提供會員服務的情況下，否則用戶獲得會員服務長期有效。因心光會員屬於虛擬產品，在您開通會員並完成支付時，深圳市心裡有光科技有限公司將認為您已了解本服務協議並明確會員所享受的權利範圍，因會員一經開通立刻生效，除非法律規定的情況或深圳市心裡有光科技有限公司提供的服務範圍與本協議所描述的會員權利不相符，否則無法退訂和退款。"
        },
        //第六節
        section6: {
            notice: "本協議自會員選擇接受或使用本服務後生效，直至會員終止本服務或註銷會員資格時終止。此外如深圳市心裡有光科技有限公司無法再提供本協議所規定的相關服務時，本協議也將終止，但深圳市心裡有光科技有限公司會在上述情況發生前積極與心光用戶取得聯繫並告知用戶本協議終止的時間，保障用戶權利。",
            otherWise: "如發生以下任何一種情況，深圳市心裡有光科技有限公司有權隨時終止本協議向用戶提供的服務，無需對用戶或第三方承擔任何責任，由此造成的損失由用戶自行獨立承擔：",
            case: [
                "用戶違反中華人民共和國相關法律法規或本協議中規定的使用規則；",
                "用戶侵犯個人、企事業單位或社會團體的合法權益，包括但不限於專利權、著作權、商標權、姓名權、名稱權、名譽權、榮譽權、肖像權、隱私權等。",
                "不允許發布令人反感的內容動態，例如：色情、恐怖、涉政、暴力、血腥、辱罵、廣告等。"
            ]
        },
        //第七節
        section7: {
            notice: "如果一方違約，守約方有權通過雙方約定的爭議解決方式獲得補償。"
        },
        //第八節
        section8: {
            notice: "深圳市心裡有光科技有限公司與用戶應通過協商來解決本協議在履行過程中所產生的爭議，經協商無法解決的，任何一方均有權將爭議提交訴訟解決。本協議的解釋、效力和執行等有關問題均適用中華人民共和國法律。"
        }
    }

};
